/** Pedidos Ofima en SGL. baseURL de axios ya incluye /api. */
export const OFIMA_PEDIDOS_PATH = '/erp-api/ofima/pedidos'

export function ofimaPedidoByOrdenPath(orden: string): string {
  return `${OFIMA_PEDIDOS_PATH}/${encodeURIComponent(orden.trim())}`
}
